import { IconButton } from '@raptormaps/button';
import { Table } from '@raptormaps/table';
import { Checkbox } from '@raptormaps/checkbox';
import type { OrgUser } from '../../api/types/OrgUser';
import { Stack } from '@raptormaps/layout';
import { CircularProgress } from '@raptormaps/progress';

interface SentryPermittanceProps {
  users?: OrgUser[];
  onRemoveUser?: (user: OrgUser) => void;
  changePermissions: (userId: number, permission: string) => void;
  isLoading: boolean;
}

const tableColumns = [
  {
    name: 'Email',
    key: 'email',
  },
  {
    name: 'Pilot',
    key: 'sentryPilot',
  },
  {
    name: 'Admin',
    key: 'sentryAdmin',
  },
  {
    name: 'Mission Builder + View',
    key: 'sentryViewer',
  },
  {
    name: 'Remove',
    key: 'remove',
  },
];

export const SentryPermittance = ({
  users,
  onRemoveUser,
  changePermissions,
  isLoading,
}: SentryPermittanceProps) => {
  const formatData = () =>
    users?.map(user => ({
      email: user.email,
      sentryPilot: (
        <Checkbox
          checked={user.sentryPilot}
          onCheckedChange={() => changePermissions(user.id, 'sentryPilot')}
          size="small"
          style={{ marginLeft: 4 }}
        />
      ),
      sentryViewer: (
        <Checkbox
          checked={user.sentryViewer}
          onCheckedChange={() => changePermissions(user.id, 'sentryViewer')}
          size="small"
          style={{ marginLeft: 4 }}
        />
      ),
      sentryAdmin: (
        <Checkbox
          checked={user.sentryAdmin}
          onCheckedChange={() => changePermissions(user.id, 'sentryAdmin')}
          size="small"
          style={{ marginLeft: 4 }}
        />
      ),
      remove: (
        <IconButton
          aria-label="Remove user"
          icon="TrashCan"
          onClick={() => onRemoveUser?.(user)}
          size="small"
          variant="tertiary"
        />
      ),
    }));

  if (isLoading || !users?.length) {
    return (
      <Stack align="center" style={{ padding: 24 }}>
        <CircularProgress size={75} />
      </Stack>
    );
  }
  return (
    <div style={{ marginTop: '20px' }}>
      <Table
        cols={tableColumns}
        data={formatData() ?? []}
        totalRowCount={1}
        fetchData={() => Promise.resolve()}
        hideControls
      />
    </div>
  );
};
